export const DIAL_PAD_KEYS = [
	{ label: '1', letters: '' },
	{ label: '2', letters: 'ABC' },
	{ label: '3', letters: 'DEF' },
	{ label: '4', letters: 'GHI' },
	{ label: '5', letters: 'JKL' },
	{ label: '6', letters: 'MNO' },
	{ label: '7', letters: 'PQRS' },
	{ label: '8', letters: 'TUV' },
	{ label: '9', letters: 'WXYZ' },
	{ label: '*', letters: '' },
	{ label: '0', letters: '+' },
	{ label: '#', letters: '' },
] as const;
